import axios from 'axios';

export const historyService = {
    getHistoryService: (onModel, queryParams) => axios.get(`/history/${onModel}`, { auth: true, params: { ...queryParams } }),

    getStaffHistoryService: (staffId, queryParams) => axios.get(`/history/staff/${staffId}`, { auth: true, params: { ...queryParams } }),
};
